import React from 'react';

function XThick(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M20.9142 5.91324C21.6953 5.13219 21.6953 3.86586 20.9142 3.08481C20.1332 2.30376 18.8668 2.30376 18.0858 3.08481L12 9.1706L5.91421 3.08481C5.13316 2.30376 3.86684 2.30376 3.08579 3.08481C2.30474 3.86586 2.30474 5.13219 3.08579 5.91324L9.17157 11.999L3.08579 18.0848C2.30474 18.8659 2.30474 20.1322 3.08579 20.9132C3.86684 21.6943 5.13316 21.6943 5.91421 20.9132L12 14.8274L18.0858 20.9132C18.8668 21.6943 20.1332 21.6943 20.9142 20.9132C21.6953 20.1322 21.6953 18.8659 20.9142 18.0848L14.8284 11.999L20.9142 5.91324Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default XThick;
